export enum FrequencyEnums  {
  IsolatedFrequency = 1,
  DailyFrequency = 2,
  WeeklyFrequency = 3,
  MonthlyFrequency = 4,
};
